import React from "react";
import moment from "moment";
import { withTranslation } from "react-i18next";

import AdherenceStats from "./AdherenceStats";
import AdherenceChartNew from "./AdherenceChartNew";
import AdherenceChartNewMobile from "./AdherenceChartNewMobile";
import CheckboxInput from "../../../../parts/checkbox-input";

class NutritionAdherence extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataView: "avg",
      showAverages: false,
    };

    this.handleDataViewChange = this.handleDataViewChange.bind(this);
    this.handleShowAverages = this.handleShowAverages.bind(this);
  }

  handleDataViewChange(dataView) {
    this.setState({ dataView });
  }

  handleShowAverages(e) {
    e.persist();
    const { checked } = e.target;
    this.setState({ showAverages: checked });
  }

  render() {
    const {
      dateFrom,
      dateTo,
      stats,
      nutritionPlans,
      averageStats,
      activeExercises,
      t,
    } = this.props;
    const { dataView, showAverages } = this.state;

    // Gets the stats that do have nutrients
    const filteredStats = stats.filter(({ nutrients }) => !!nutrients);

    if (filteredStats.length === 0) {
      const { t } = this.props;
      return (
        <div className="nutrition-adherence empty-state">
          <div className="adherence-head">
            <span className="adherence-range">
              {t("nutritionPage.adherence.noDataToShow")}
            </span>
          </div>
        </div>
      );
    }

    // Gets the average stats that do have nutrients
    const filteredAverageStats = averageStats.filter((stat) =>
      Object.values(stat.nutrients).some((val) => val > 0)
    );

    return (
      <div className="nutrition-adherence">
        <div className="adherence-head">
          <span className="adherence-range">
            {t("nutritionPage.adherence.fromTo", {
              dateFrom: moment(dateFrom).format("MMM D, YYYY"),
              dateTo: moment(dateTo).format("MMM D, YYYY"),
            })}
          </span>
          <div className="unit-container">
            <button
              data-button-type={dataView === "avg" ? "outline" : "secondary"}
              onClick={() => this.handleDataViewChange("avg")}
              sz="small"
            >
              <span>{t("nutritionPage.adherence.avg")}</span>
            </button>
            <button
              data-button-type={dataView === "total" ? "outline" : "secondary"}
              onClick={() => this.handleDataViewChange("total")}
              sz="small"
            >
              <span>{t("nutritionPage.adherence.total")}</span>
            </button>
          </div>
        </div>
        <div className="radio-group mobile-hidden">
          <CheckboxInput
            inputName="showAverage"
            id="showAverageAdherence"
            checked={showAverages}
            onChangeFn={this.handleShowAverages}
            labelText={t("nutritionPage.adherence.showAveragesOnly")}
          />
        </div>
        <div className="adherence-table">
          <AdherenceStats
            dateFrom={dateFrom}
            dateTo={dateTo}
            stats={filteredStats}
            dataView={dataView}
            nutritionPlans={nutritionPlans}
            activeExercises={activeExercises}
          />
        </div>

        <div className="adherence-chart-new">
          <div className="mobile-hidden">
            <AdherenceChartNew
              stats={filteredStats}
              dateFrom={dateFrom}
              dateTo={dateTo}
              averageStats={filteredAverageStats}
              nutritionPlans={nutritionPlans}
              showAverages={showAverages}
              activeExercises={activeExercises}
            />
          </div>
          <div className="only-show-mobile">
            <AdherenceChartNewMobile
              stats={filteredStats}
              dateFrom={dateFrom}
              dateTo={dateTo}
              averageStats={filteredAverageStats}
              nutritionPlans={nutritionPlans}
              showAverages={showAverages}
              activeExercises={activeExercises}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("athlete-portal")(NutritionAdherence);
